// Multivariate Dependencies
import React, { forwardRef } from 'react';
// Components
import { Icon } from '../../Icon';
import { Label } from '../../Label';
import { TextButtonStylePropertiesBySize } from '../types/TextButtonStylePropertiesBySize';
export var TextButtonStructure = forwardRef(function (_a, ref) {
    var className = _a.className, children = _a.children, size = _a.size, icon = _a.icon, disabled = _a.disabled, onClick = _a.onClick, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var labelSize = TextButtonStylePropertiesBySize[size].labelSize;
    return (React.createElement("button", { ref: ref, className: className, disabled: disabled, onClick: onClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        icon && React.createElement(Icon, { name: icon, ariaLabel: undefined }),
        React.createElement(Label, { size: labelSize, styleVariant: 'regular' }, children)));
});
//# sourceMappingURL=TextButtonStructure.js.map